import { render, staticRenderFns } from "./BaseThumbnail.vue?vue&type=template&id=9688112c&scoped=true&"
import script from "./BaseThumbnail.vue?vue&type=script&lang=js&"
export * from "./BaseThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./BaseThumbnail.vue?vue&type=style&index=0&id=9688112c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9688112c",
  null
  
)

export default component.exports